<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <span>لیست کالاهایی که نیاز به تغییر قیمت دارند</span>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <ProductInfoSearchResult :is-selection-form="false"
                               :buy-list="true"
                               :show-groups="true"
                               :by-pass-insert-dialog="false"
                               title-select-good-dialog="تعداد سفارش" />
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductInfoSearchResult from "@/components/productInfo/ProductInfoSearchResult.vue";
import EventBus from "@/event-bus";

export default {
  name: "GoodsPriceList",
  components: {ProductInfoSearchResult},

  data() {
    return {
      items: []
    }
  },
  methods: {
    ...mapActions({
      changePriceList: 'Products/getProductForChangePrice'
    }),
  },
  created() {
    this.changePriceList().then((res) => {
      this.items = res
      EventBus.$emit('invoke-productinfo-search-result-event', this.items);
    })
  }
}
</script>

<style scoped>

</style>